import { message } from "antd";
import { routesName, setAccessToken, storeToken, usePostLogin } from "core";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";


export const USERName = "userName";
export const PASSWORD = "password";

const useLogic = () => {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const [messageApi, contextHolder] = message.useMessage();

  const methods = useForm({
    defaultValues: {
      userName: "",
      password: "",
    },
  });

  const {
    handleSubmit,
    formState: { errors },
  } = methods;

  const dispatch = storeToken.useDispatch();
  
 
  const {mutate}=usePostLogin({
    
    onSuccess: (data) => {
      if(data?.permissions?.map((item:any)=>{return item}).includes("admin")|| data?.permissions?.map((item:any)=>{return item}).includes("operator")){
      dispatch(setAccessToken(data?.tokens?.data?.accessToken))
      navigate(routesName.DASHBOARD);
    }else{
      messageApi.open({
        type: "error",
        content:i18n.t("youDontHavePermision") ,
      })
    }},
    onError:()=>{
      messageApi.open({
        type: "error",
        content:i18n.t("enterFalseValue") ,
      })
    }
  });

  

  const login =  ({ userName,password }: { userName: string,password:string}) => {
    // Implement your login logic here

      mutate({ requestBody: {userName,password} });

  };

  return {
    contextHolder,
    login,
    handleSubmit,
    methods,
  };
};

export { useLogic };
